import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import Datetime from '../../../../components/user/from/Datetime/indexV2'
import InputUpload from '../../../../components/user/from/InputUpload'
import SelectStatus from '../../../../components/user/from/SelectStatus'
import { numberWithCommas } from '../../../../utils/number'
import { reDurationType } from '../../../../utils/leave'
import moment from 'moment'
import IframeFile from '../../../../components/user/IframeFile'
import ImageFileNewtab from '../../../../components/user/ImageFileNewtab'
import { changeFormatdate, changeFormatFulldate, changeFormatdateThai } from '../../../../utils/formatdate'
import { approveStatus, approveStatusNew } from '../../../../utils/leave'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import { profileObjectKey, employeeDetailObjectKey } from '../../../../utils/auth'
import { checkLinkURL } from '../../../../utils/auth'
import ComponetsRemarkText from '../Components/remarkText'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
   //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfile = '';
const format = 'HH:mm';

class Withdraw extends Component {
	state = {
		loading:false,
		dataTalbeUploads: [
			// {
			// 	documentType: null,
            //     description:null,
			// 	attachFile:null,
            //     statusFile:false
			// },
		],
      columns: [
         {
            title: 'ประเภทเอกสาร',
            dataIndex: 'documentType',
            align:'center',
            vertical:'top',
            render: (item, record, index) => {
               return(
                  <>
                        <Form.Item label={""}>
                           { this.props.form.getFieldDecorator("documentType"+index, {
                              initialValue: item ? item : [],
                              rules:  [{ 
                                    message: 'กรุณาเลือกลือกไฟล์',
                              }],
                           })(
                              <Select 
                                    style={{ width: "100%" }}
                                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                                    disabled={true}
                                    showSearch
                                    placeholder="กรุณาเลือก"
                                    optionFilterProp="children"
                                    disabled={ record.fileId ? true : false }
                              >
                                    {
                                       DOCUMENT_TYPE.map((valuesLabel, keys)=>{
                                          return <Option value={valuesLabel.value}>{ valuesLabel.label }</Option>
                                       })
                                    }
                              </Select>
                           )}
                        </Form.Item>
                  </>
               )
            }
         },
         {
            title: 'รายละเอียดเพิ่มเติม',
            dataIndex: 'description',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               return(
                  <>
                        <Form.Item label={""}>
                           { this.props.form.getFieldDecorator("description"+index, {
                              initialValue: item,
                              rules:  [{ 
                                    required: record.statusFile ? true : false, 
                                    message: 'กรุณากรอกรายละเอียด',
                              }],
                           })(
                              <Input 
                                    disabled={true}
                                    disabled={ record.fileId ? true : false }
                                    // defaultValue={item} 
                                    // onBlur={ (e) => this.onChangeValueForm(index, e, 'description') }
                              />
                           )}
                        </Form.Item>
                  </>
               )
            }
         },
         {
            title: 'เอกสารแนบ',
            dataIndex: '7',
            width:'200px',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               return (
                  <>
                     { this.inputFormUploads(index) }
                  </>
               )
            }
         },
         {
            title: 'จัดการ',
            dataIndex: '7',
            width:'20px',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               // return this.showDetailBtnInput(record, index)
               return  <Avatar 
                           disabled={true}
                           shape="square"  
                           icon={<Icon type="delete" />} 
                           className="mr-1 mb-1"  
                           style={{ cursor: 'not-allowed' }}
                        />
            }
         },
      ],
      pageData: {
         offset: 0,
         limit: 10
      },
      pagination: {
         total: 10,
      },
      dataTalbeLength:1,
      preLoadOnsubmit: false,
      detailProfile:null,
      dropdownApproverMedical:[],
		dateTimeValue:moment(),
      leaveTypeId:null,
      leaveDay:null,
      showleaveDay:null,
      currentLeaveDay:null,
      remainLeaveDay:null,
      dropdownLeaveType:[],
      empCode:null,
      isCanLeaveOver:null,
      maxLeaveDay:null,
      minLeaveDay:null,
      reqAttachDay:null,
      reqAttachDayStatus:false,
      detailForm:null,
      loadingColumnsPeople:true,
      dataTalbePeople: [],
      columnsPeople: [
         {
               title: 'ลำดับ',
               dataIndex: 'docId',
               width:'8%',
         align:'center',
               render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
         },
         {
               title: 'วันที่ดำเนินรายการ',
               dataIndex: 'createdAt',
               width:'20%',
               align:'center',
               // render: (item, record, index) => <span>{moment(item).format('DD-MM-YYYY')}</span>
               render: (item, record, index) => <span>{ item ? changeFormatFulldate(item) : '-'}</span>
         },
      {
               title: 'ผู้ดำเนินรายการ ',
               width:'20%',
               dataIndex: 'userAction',
               align:'center',
               render: (item, record, index) => <span>{ item }</span>
         },
         {
               title: 'สถานะ',
               dataIndex: 'approveStatus',
               width:'200px',
         align:'center',
               render: (item, record, index) => <span>{ approveStatus(item) }</span>
         },
         {
               title: 'หมายเหตุ',
               dataIndex: 'noteApprove',
               width:'200px',
         align:'center',
               render: (item, record, index) => <>
                  {
                     item ?
                           <span 
                              onClick={()=>{this.showModalNode(item)}} 
                              style={{ cursor:"pointer" }}
                              className="btn-show-fileuploads"
                           > 
                              อ่านหมายเหตุ
                           </span>
                     : '-'
                  }
                  
               </>
         },
      ],
      statusCanEdit:false,
      dropdowndurationType:[],
      empCode:null,
      detailProfileName:null,
      showNullForm:null,
      dataTalbeAttendance: [
      {
         dateFirstLeave: moment(),
               empCodeLeave:5594825,
               timeFirst: moment(),
         timeLast: moment().add(5, 'hours'),
               statusFile:false
      },
      {
         dateFirstLeave: moment().add(1, 'days'),
               empCodeLeave:5594825,
               timeFirst: moment().add(2, 'hours'),
         timeLast: moment().add(7, 'hours'),
               statusFile:false
      },
      {
         dateFirstLeave: moment().add(2, 'days'),
               empCodeLeave:5594825,
               timeFirst: moment().add(-7, 'hours'),
         timeLast: moment().add(6, 'hours'),
               statusFile:false
      },
      ],
      columnsAttendance: [
         {
            title: 'วันที่ขอลา',
            dataIndex: 'dateFirstLeave',
            align:'center',
            vertical:'top',
            render: (item, record, index) => {
               return(
                  <>
                        <label>
                           { changeFormatdate(item) }
                        </label>
                        {/* <Form.Item label={""}>
                           { this.props.form.getFieldDecorator("documentType"+index, {
                              initialValue: item,
                              rules:  [{ 
                                    required: record.description ? true : false,
                                    message: 'กรุณาเลือกประเภทเอกสาร',
                              }],
                           })(
                              <Input 
                                    disabled={true}
                              />
                           )}
                        </Form.Item> */}
                  </>
               )
            }
         },
         {
               title: 'รหัสกะงาน',
               dataIndex: 'empCodeLeave',
            align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { item }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: 'timeFirst',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: 'timeLast',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: '655',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("655"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker 
                                       format={format} 
                                       placeholder="" 
                                       // disabledHours={() => this.getDisabledHours(record)}
                                       // disabledMinutes={(e) => this.getDisabledMinutes(e, record)}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: '444',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("444"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker format={format} placeholder="" />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'จำนวน ซม.',
               dataIndex: '123',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("123"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <Input 
                                       disabled={true}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
      ],
      statusForm: null,
      historyYear: null,
      leaveDayAllData: [],
      manualLeave: [],
      showStatus: null
	}

    dateFormatNumber = (values) =>{
        let valueReturn = this.props.form.getFieldValue(values)
        return changeFormatdate(moment(valueReturn))
    }

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };

    dropdownLeaveType = async ()=>{
        const { client, location, match } = this.props
        const { empCode } = this.state

        if(empCode){
            const { data, errors } = await client.query({
                query: Queries.dropdownLeaveType,
                variables:{
                    empCode,
                    isReqByEmp:false
                }
            })
    
    
            if(data.dropdownLeaveType){
                await this.setState({
                    dropdownLeaveType: data.dropdownLeaveType,
                })
            }
        }
       
    }

    fetchLeaveDay = async() =>{
        const { client, location, match } = this.props
        const { leaveTypeId, isCanLeaveOver, empCode } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDay,
            variables:{
                empCode,
                leaveTypeId,
                reqLeaveDate: moment()
            }
        })

        if(data.fetchLeaveDay){
            await this.setState({
                showleaveDay: data.fetchLeaveDay.leaveDay,
                currentLeaveDay: data.fetchLeaveDay.currentLeaveDay,
                remainLeaveDay: data.fetchLeaveDay.remainLeaveDay,
            })
        }else{
            await this.setState({
                showleaveDay: null,
                currentLeaveDay: null,
                remainLeaveDay: null
            })
        }
    }

    fetchWorkingDay = async(leaveStartDate, leaveEndDate) =>{
        const { client, location, match } = this.props
        const { empCode, leaveTypeId, reqAttachDay } = this.state

        const { data, errors } = await client.query({
            query: Queries.fetchWorkingDay,
            variables:{
                empCode,
                leaveTypeId,
                leaveStartDate,
                leaveEndDate
            }
        })

        if(data.fetchWorkingDay){
            await this.setState({
                leaveDay: data.fetchWorkingDay.day,
            })

            await this.fetchApproverLeave()
            
            await this.props.form.setFieldsValue({
                leaveDay: data.fetchWorkingDay.day,
            })

            if(reqAttachDay !== 0){
                if(reqAttachDay < data.fetchWorkingDay.day){
                    await this.setState({
                        reqAttachDayStatus:false
                    })
                }else{
                    this.setState({
                        reqAttachDayStatus:true
                    })
                }
            }
        }
        
    }

    onChangeTypeLeave = async (leaveTypeId)=>{
        
        const { dropdownLeaveType } = this.state
        
        if(leaveTypeId){
            // console.log('dropdownLeaveType',dropdownLeaveType)
            dropdownLeaveType.filter(valuesName => valuesName.value == leaveTypeId).map(async (valueArray) => {
                await this.setState({
                    dropdowndurationType : valueArray.dropdownDurationType,
                    isCanLeaveOver: valueArray.isCanLeaveOver,
                    maxLeaveDay: valueArray.maxLeaveDay,
                    minLeaveDay: valueArray.maxLeaveDay,
                    reqAttachDay: valueArray.reqAttachDay
                })
            })
            await this.setState({
                leaveTypeId
            })
            await this.fetchLeaveDay()
            await this.fetchWorkingDay(moment(), moment())
            await this.props.form.setFieldsValue({
            	leaveStartDate: moment(),
            	leaveEndDate: moment(),
                durationType: "Full"
            })
        }
    }

    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeLength, dataTalbeUploads } = this.state
        console.log('dataTalbeLength',dataTalbeLength)
        return(
            <>
                {
                    dataTalbeUploads.length > 1 ? 
                            <>
                                {
                                    record.fileId ?
                                        <Popconfirm
                                            placement="topRight"
                                            title={"คุณต้องการที่จะลบไฟล์"}
                                            onConfirm= { () => this.deleteAttachmentFile(dataTalbeUploads[arrayId].fileId, arrayId) }
                                            okText="ตกลง"
                                            cancelText="ยกเลิก"
                                        >
                                            <Avatar 
                                                shape="square"  
                                                icon={<Icon type="delete" />} 
                                                className="mr-1 mb-1 bg-red"  
                                                style={{ cursor: 'pointer', background:"red" }}
                                            />
                                        </Popconfirm>
                                    :
                                        <Avatar 
                                            shape="square"  
                                            icon={<Icon type="delete" />} 
                                            className="mr-1 mb-1 bg-red"  
                                            onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                            style={{ cursor: 'pointer', background:"red" }}
                                        />
                                }
                            </>
                    : 
                        <>
                            {
                                record.fileId ?
                                    <Avatar 
                                        disabled={true}
                                        shape="square"  
                                        icon={<Icon type="delete" />} 
                                        className="mr-1 mb-1 bg-red"  
                                        style={{ cursor: 'not-allowed' }}
                                    />
                                :
                                    <Avatar 
                                        disabled={true}
                                        shape="square"  
                                        icon={<Icon type="delete" />} 
                                        className="mr-1 mb-1 bg-red"  
                                        onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                        style={{ cursor: 'not-allowed' }}
                                    />
                            }
                        </>
                }
            </>
        )
    }

    deleteAttachmentFile = async (fileId, arrayId) =>{
        const { form, afterSubmit, client, match } = this.props
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.deleteAttachmentFile,
                variables: {
                    fileId,
                    docId: match.url.split('/')[4]
                }
            })

            if(data){
                message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                await this.destroyArrayDataUploads(arrayId)
                // setTimeout(() => {
                //     window.location.reload();
                // }, 600);
            }
        }catch (error) {
            
        }
    }

    showDataInputUploads = async () =>{
        const { dataTalbeUploads, reqAttachDayStatus } = this.state
        const rows = {
            fileId:null,
            documentType: null,
            statusFile: false,
            description: null,
            attachFile: null,
        }
        await this.setState(prevState => ({
            dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        }), async () => {
            let lengthData = dataTalbeUploads.length+1;
            await this.setState({
                dataTalbeLength: lengthData
            })
        })
    }

    handleAdd = async (images, arrayId ) => {
        const { dataTalbeUploads, reqAttachDayStatus } = this.state
        if(images){
            const isLt2M = images.size / 1024 / 1024 < 1;
            const fileType = images.name.substr(images.name.lastIndexOf("."));
            const dotIndex = images.name.indexOf(fileType)
            const fileName = images.name.substring(0, dotIndex)
			if (!isLt2M) {
				message.error('ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง');
                let dataSourceitems = [...this.state.dataTalbeUploads];
                let item = {...dataTalbeUploads[arrayId]};
                item = {
                    fileId:null,
                    documentType: item.documentType,
                    statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                    description: item.description,
                    attachFile: null,
                }
                dataSourceitems[arrayId] = item;

                await this.setState(({
                    dataTalbeUploads: dataSourceitems,
                }), () => {
                    // this.cllBackSetValueOrganizatuions()
                })
			} else if (fileName.includes(".")) {
            message.error('ชื่อไฟล์ไม่สามารถมีจุด (.) ได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
         } else{
                let dataSourceitems = [...this.state.dataTalbeUploads];
                let item = {...dataTalbeUploads[arrayId]};
                item = {
                    fileId:null,
                    documentType: item.documentType,
                    statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                    description: item.description,
                    attachFile: images,
                }
                dataSourceitems[arrayId] = item;

                await this.setState(({
                    dataTalbeUploads: dataSourceitems,
                }), () => {
                    // this.cllBackSetValueOrganizatuions()
                })
			}
        }
	}

    modalShowFile = async (dataFile, title) =>{
        Modal.info({
            className:"modalFickIcons",
            title: "ไฟล์อัปโหลดเอกสาร",
            width:"800px",
            content: (
              <div >
                  <hr></hr>
                  <div className="pt-4">
                     {
                     dataFile.fileType == 'application/pdf' ?
                           <IframeFile typeFile={dataFile.fileType}  file={dataFile.attachFile} formUpload={true}/>
                     :
                           <ImageFileNewtab typeFile={dataFile.fileType}  file={dataFile.attachFile} formUpload={true}/>
                     }
                  </div>
              </div>
            ),
            okText: 'ปิด',
            onOk() {},
            // closable:({disabled:false})
        });
    }

    inputFormUploads = (arrayId) =>{
        const { dataTalbeUploads } = this.state
        let fileName = dataTalbeUploads[arrayId].attachFile ? dataTalbeUploads[arrayId].attachFile.name ? dataTalbeUploads[arrayId].attachFile.name : null : null
        let fileNameShow = fileName ? fileName.length <= 10 ? fileName : fileName.slice(0,10)+'...'+fileName.slice(-4) : ''
        return(
            <>
                {
                    dataTalbeUploads[arrayId].fileId ? 
                        <>
                            {
                                dataTalbeUploads[arrayId].attachFile ? 
                                    <>
                                        <Text 
                                            onClick={ () => { this.modalShowFile(dataTalbeUploads[arrayId], 'เอกสารแนบ') }} 
                                            style={{ cursor:"pointer" }}
                                            className="btn-show-fileuploads"
                                        >
                                            ดูไฟล์อัปโหลด
                                        </Text>
                                        <br></br>
                                    </>
                                : '-'
                            }
                            {/* <Text 
                                onClick={ () => { this.modalShowFile(dataTalbeUploads[arrayId], 'เอกสารแนบ') }} 
                                style={{ cursor:"pointer" }}
                            >
                                ดูไฟล์อัปโหลด
                            </Text>
                            <br></br> */}
                        </>
                    : <>
                        <label for={"input-file-"+arrayId} class="custom-file-upload">
                            <p className="py-2 px-4" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                                อัปโหลด
                            </p>
                        </label>
                        <span className={ fileName ? '' : "color-red"  }>
                            { 
                                fileName ? 
                                fileNameShow :
                                // fileName.slice(0,10)+'...'+splitTypeFile.split('/')[1] : 
                                "กรุณาเลือกอัปโหลดรูปภาพหรือไฟล์"  
                            }
                        </span>
                        <input
                            id={"input-file-"+arrayId}
                            className="input-file"
                            // name={uploadName}
                            type="file"
                            accept="file_extension"
                            accept="image/png, image/jpeg, application/pdf"
                            // rules={ true }
                            onChange={e => this.handleAdd(e.target.files[0],arrayId)}
                        />
                    </>
                
                }
            </>
        )
    }

    fetchCountListAllApproving = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountListAllApproving,
		})

		sessionStorage.setItem('totalLeaveCount', data.fetchCountListAllApproving.leaveCount);
		sessionStorage.setItem('totalWdHospitalCount', data.fetchCountListAllApproving.wdHospitalCount);

		if(document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		}

		// if(document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		// }

		if(document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		}

		// if(document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		// }
	}

    sendToCreateLeave = async (values) => {
        const { form, client, match } = this.props
        const { 
            detailForm,
            dataTalbeUploads,
            reqAttachDay,
            leaveDay,
            ModalConfirmFormStatus,
            ModalConfirmFormMessage
        } = this.state
        
         await this.setState({
            preLoadOnsubmit: true,
            loadingFullpage: true
        })

        await this.hideModalConfirm()

      //   e.preventDefault()
		// form.validateFields(async (err, values) => {
      //       if (!err) {
         try {
            let approversDropDown = []
            let attachFiles = []
            let checkModal = false

            if(dataTalbeUploads.length !== 0){
               // console.log('dataTalbeUploads.length', dataTalbeUploads.length )
               dataTalbeUploads.map((valuesFile , keyValuesFile) =>{
                     if(!valuesFile.fileId){
                        if(dataTalbeUploads.length !== 0){
                           dataTalbeUploads.map((valuesFile , keyValuesFile) =>{
                                 if (reqAttachDay != 0 && reqAttachDay < leaveDay) {
                                    if(!valuesFile.description || !valuesFile.attachFile){
                                       checkModal = true
                                    }
                                 }else if(valuesFile.documentType == 'อื่น ๆ'){
                                    if(!valuesFile.description || !valuesFile.attachFile ){
                                       checkModal = true
                                    }
                                 }else if(valuesFile.documentType){
                                    if(!valuesFile.attachFile){
                                       checkModal = true
                                    }
                                 }
   
                                 if(valuesFile.documentType || valuesFile.description || valuesFile.attachFile){
                                    let dataArray = {
                                       documentType: valuesFile.documentType ? valuesFile.documentType : '',
                                       description: valuesFile.description ? valuesFile.description : '',
                                       attachFile: valuesFile.attachFile,
                                    }
   
                                    attachFiles.push(dataArray)
                                 }
                           })
                        }
                     }
               })
            }

            if(checkModal){
               Modal.error({
                     title: 'กรุณาอัปโหลดรูปภาพหรือไฟล์',
                     className:'custom-modal-error',
                     okText: 'ตกลง',
               });
               this.setState({
                     preLoadOnsubmit: false
               })
            }else{
               const { data, errors } = await client.mutate({
                     mutation: Mutations.updateLeaveDocument,
                     variables: {
                        documentDate: values.documentDate,
                        docId: match.url.split('/')[4],
                        durationType: detailForm.durationType,
                        approveStatus: ModalConfirmFormStatus,
                        description: values.description,
                        noteApprove: values.noteApprove,
                        attachFiles,
                        leaveStartDate: values.leaveStartDate,
                        leaveEndDate: values.leaveEndDate,
                        noteApprove: values.ModalNoteApprove,
                        autoApprove: false,
                        clientType: "WEB_CLIENT",
                     }
               })

               if(data){
                     message.success(ModalConfirmFormMessage)
                     await this.fetchCountListAllApproving()
                     setTimeout(() => {
                        window.location.href = '/Leave/Confirm/'
                     }, 2000);
                     await this.setState({
                        preLoadOnsubmit: false,
                        loadingFullpage: false
                     })
               }else{
                  await this.setState({
                     preLoadOnsubmit: false,
                     loadingFullpage: false
                  })
               }
            }
         }catch (error) {
            await this.setState({
               preLoadOnsubmit: false,
               loadingFullpage: false
            })
            console.log('error',error)
         }
			// }else{
         //       await this.setState({
         //            preLoadOnsubmit: false,
         //            loadingFullpage: false
         //        })
         //    }
		// })

        // totalWithdraw = summaryTotalTable
    }

    showModalFormConfirm = async (e, status, messageShow, title, textBtnOK, ModalFormTextArea, ModalFormTextAreaRequie) =>{
      const { form, client } = this.props
        this.setState({
            preLoadOnsubmit: true,
            // loadingFullpage: true
        })

         e.preventDefault()
		   form.validateFields(async (err, values) => {
            if (!err) {
               try {
                  await this.setState({
                     ModalConfirmFormTitle:title,
                     ModalConfirmFormShowModal:true,
                     ModalConfirmFormBtnOk:textBtnOK,
                     ModalConfirmFormBtnCancel:'ยกเลิก',
                     ModalConfirmFormValue:values,
                     ModalConfirmFormStatus: status,
                     ModalConfirmFormMessage: messageShow,
                     ModalFormTextArea,
                     ModalFormTextAreaRequie
                 })
               }catch (error) {
                  await this.setState({
                     preLoadOnsubmit: false,
                     // loadingFullpage: false
                  })
                  console.log('error',error)
               }
            }else{
               await this.setState({
                  preLoadOnsubmit: false,
                  // loadingFullpage: false
               })
         }
		})
    }

    hideModalConfirm = async () =>{
      await this.setState({
          ModalConfirmFormTitle:null,
          ModalConfirmFormSubTitle:null,
          ModalConfirmFormShowModal:false,
          ModalConfirmFormBtnOk:null,
          ModalConfirmFormBtnCancel:null,
          ModalConfirmFormValue:null,
          ModalConfirmFormStatus:null,
          ModalConfirmFormMessage:null,
          preLoadOnsubmit: false
      })
  }
    
    handleSubmit = async (e) => {
        const { isCanLeaveOver, remainLeaveDay, leaveDay, maxLeaveDay, minLeaveDay, reqAttachDay } = this.state
        // console.log('asfdsaf',e)
      //   this.sendToCreateLeave(e, 'Y', 'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย')
      await this.showModalFormConfirm(e,'Y', 'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย', 'ท่านต้องการยืนยันอนุมัติการขอลา?', 'ยืนยัน', true, false)
    }

    handleSubmitCancel = async (e) => {
        const { isCanLeaveOver, remainLeaveDay, leaveDay, maxLeaveDay, minLeaveDay, reqAttachDay } = this.state
        // console.log('asfdsaf',)
      //   this.sendToCreateLeave(e, 'N', 'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย')
      await this.showModalFormConfirm(e,'N', 'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย', 'ท่านต้องการยืนยันไม่อนุมัติการขอลา?', 'ยืนยัน', true, true)
    }

    destroyArrayDataUploads =  async (arrayId) =>{
        const { dataTalbeUploads } = this.state
        var arrayDataSource = [...this.state.dataTalbeUploads];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTalbeUploads:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            let lengthData = arrayDataSource.length;
            await this.setState({
                dataTalbeLength: lengthData
            })
			// this.cllBackSetValueContactNumber()
		})
    }

    fetchLeaveDocumentDetail = async()=>{
        const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

      console.log('123123', match.url.split('/')[4])

        await this.setState({
            preLoadSubmit:true,
            loading:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDocumentDetail,
            variables:{
                docId: match.url.split('/')[4]
                // leaveStartDate:disabledDateStart,
                // leaveEndDate:endStartValues,
                // leaveTypeId:"1",
            }
        })

        console.log('fetchLeaveDocumentDetail',data.fetchLeaveDocumentDetail)

        if(data.fetchLeaveDocumentDetail){
            await this.setState({
                dataTalbeUploads: data.fetchLeaveDocumentDetail.attachFiles,
                detailForm: data.fetchLeaveDocumentDetail,
                empCode: data.fetchLeaveDocumentDetail.empCode,
                loadingFullpage: false,
                leaveTypeCategory: data.fetchLeaveDocumentDetail.durationType
            })

            await this.fetchLeaveDayAll()
        }else{
            await this.setState({
                showNullForm:true,
                loading:false,
                preLoadSubmit:false,
                loadingFullpage: false
            })
        }
    }

    fetchLeaveDocumentDetailStatus = async() => {
      const { client,location ,match } = this.props
      const { offset ,limit, disabledDateStart, endStartValues } = this.state

      await this.setState({
          preLoadSubmit:true,
          loading:true
      })

      const { data, errors } = await client.query({
          query: Queries.fetchLeaveDocumentDetailStatus,
          variables:{
              docId: match.url.split('/')[4]
          }
      })

      console.log('data.fetchLeaveDocumentDetailStatus',data.fetchLeaveDocumentDetailStatus)

      if(data.fetchLeaveDocumentDetailStatus){
          await this.setState({
              showStatus: data.fetchLeaveDocumentDetailStatus.status,
          })
      }else{
          await this.setState({
              loading:false,
              preLoadSubmit:false,
          })
      }
  }

    fetchLeaveDocumentHistory = async()=>{
        const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        await this.setState({
            loadingColumnsPeople:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDocumentHistory,
            variables:{
                docId: match.url.split('/')[4]
            }
        })

        console.log('data.fetchLeaveDocumentHistory',data.fetchLeaveDocumentHistory)
        if(data.fetchLeaveDocumentHistory){
            await this.setState({
                dataTalbePeople: data.fetchLeaveDocumentHistory,
                loadingColumnsPeople:false
            })
        }else{
            await this.setState({
                loading:false,
                loadingColumnsPeople:false,
            })
        }
    }

    fetchOptionApproverLeave = async () =>{
        const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        if(match.url.split('/')[4] == 'W'){
            await this.setState({
                  preLoadSubmit:true,
                  loading:true
            })

            const { data, errors } = await client.query({
                  query: Queries.fetchOptionApproverLeave,
                  variables:{
                     docId: match.url.split('/')[4]
                  }
            })

            console.log('data.fetchOptionApproverLeave',data.fetchOptionApproverLeave)
            if(data.fetchOptionApproverLeave){
                  await this.setState({
                     statusCanEdit: data.fetchOptionApproverLeave.canEdit,
                  })
            }
        }
       
    }

    employeeDetailProfileForLeave = async () => {
        const { client, location, match } = this.props
        const { empCode } = this.state
        console.log('empCode',empCode)
        if(empCode){
            const { data, errors } = await client.query({
                query: Queries.employeeDetailProfileForLeave,
                variables:{
                    empCode
                }
            })
            console.log('data.employeeDetailProfileForLeave',data.employeeDetailProfileForLeave)
            if(data.employeeDetailProfileForLeave){
                await this.setState({
                    detailProfile: data.employeeDetailProfileForLeave,
                })
    
                await this.dropdownLeaveType()
            }else{
                await this.setState({
                    detailProfile:null
                })
            }
        }   
    }

    fetchListLeaveDocumentApprover = async () =>{
      const { form, afterSubmit, client, match } = this.props
      const { telNo, otpToken, refCode } = this.state
      try {
         const { data, errors } = await client.query({
            query: Queries.fetchListLeaveDocumentApprover,
            variables: {
               approveStatus:"A"
            }
         })

         console.log('data.fetchListLeaveDocumentApprover', data.fetchListLeaveDocumentApprover)
         console.log("match.url.split('/')[4]", match.url.split('/')[4])

         if(data.fetchListLeaveDocumentApprover){
            const detailStatus = data.fetchListLeaveDocumentApprover.find(dataArray => dataArray.docId == match.url.split('/')[4]);
            console.log('detailStatus', detailStatus)
            await this.setState({
               statusForm: detailStatus.status
            })
         }
      }catch (error) {
         console.log('error',error)
      }
    }

   fetchMasterConfigTypeLeave = async () =>{
      const { client, location, match } = this.props

      const { data, errors } = await client.query({
         query: Queries.fetchMasterConfigTypeLeave,
      })
      if(data.fetchMasterConfigTypeLeave){
         console.log('fetchMasterConfigTypeLeave', data.fetchMasterConfigTypeLeave)
         let manualLeave = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "ManualApprover")
         let remarkText = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "Remark")
         await this.setState({
            remarkText: remarkText ? remarkText[0].configValue1 : null,
            manualLeave
         })
      }
   }

   checkLeaveDayAllValue = (value) =>{
      if(value.includes('.')){
         return numberWithCommas(value)
      }else{
         return value
      }
   }


   fetchLeaveDayAll = async () =>{
      const { client, location, match } = this.props
      const { empCode } = this.state
      const { data, errors } = await client.query({
          query: Queries.fetchLeaveDayAll,
          variables:{
            empCode,
            reqLeaveDate: moment()
          }
      })
      console.log('data.fetchLeaveDayAll', data.fetchLeaveDayAll)
      if(data.fetchLeaveDayAll){
         let leaveDayAllData = data.fetchLeaveDayAll
         // let leaveDayAllData = []
         //    await data.fetchLeaveDayAll.map(valuesSelect => {
         //       if(
         //          valuesSelect.leaveTypeId == '5'
         //          // valuesSelect.leaveTypeId == '1' ||
         //          // valuesSelect.leaveTypeId == '5' ||
         //          // valuesSelect.leaveTypeId == '4'
         //       ){
         //          valuesSelect.isShowRemaVtrc = true
         //       }else{
         //          valuesSelect.isShowRemaVtrc = false
         //          // leaveDayAllData.push(valuesSelect)
         //       }

         //       leaveDayAllData.push(valuesSelect)
         //    })

         await this.setState({
            leaveDayAllData,
         })
      }

      let leaveYearStartDate = data.fetchLeaveDayAll?.length > 0 ? data.fetchLeaveDayAll[0].leaveYearStartDate.split("-") : ''
      let leaveYearEndDate =data.fetchLeaveDayAll?.length > 0 ?  data.fetchLeaveDayAll[0].leaveYearEndDate.split("-") : ''

      
      await this.setState({
          loadingleaveDayAllData:false,
          historyYear: data.fetchLeaveDayAll?.length > 0 ? changeFormatdateThai(leaveYearStartDate[2]+"-"+leaveYearStartDate[1]+"-"+leaveYearStartDate[0])+' ถึง '+changeFormatdateThai(leaveYearEndDate[2]+"-"+leaveYearEndDate[1]+"-"+leaveYearEndDate[0]) : null
      })
   }

	async componentDidMount(){

      // if(profileObjectKey && employeeDetailObjectKey){
      //    this.setState({
      //       detailProfile: employeeDetailObjectKey(),
      //       // empCode: profileObjectKey().employeeCodes[0]
      //    })
      // }

      await Promise.all(
         [
            this.dropdownLeaveType(),
            this.fetchLeaveDocumentDetailStatus(),
            this.fetchLeaveDocumentDetail(),
            this.fetchLeaveDocumentHistory(),
            this.fetchOptionApproverLeave(),
            this.fetchListLeaveDocumentApprover(),
            this.fetchMasterConfigTypeLeave()
            // this.fetchLeaveDay(),
         ]
      )
      //   await this.fetchLeaveDocumentDetail()
        await this.employeeDetailProfileForLeave()
      //   await this.fetchOptionApproverLeave()
      // //   await this.dropdownLeaveType()
      //   await this.fetchLeaveDocumentHistory()
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { 
            columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, 
            dropdownApproverMedical,
            detailProfile,
            showleaveDay,
            currentLeaveDay,
            remainLeaveDay,
            dropdownLeaveType,
            detailForm,
            showModalNote,
            noteModal,
            titleModal,
            columnsPeople,
            dataTalbePeople,
            statusCanEdit,
            dropdowndurationType,
            detailProfileName,
            loadingColumnsPeople,
            showNullForm,
            dataTalbeAttendance,
            columnsAttendance,
            ModalConfirmFormTitle,
            ModalConfirmFormSubTitle,
            ModalConfirmFormShowModal,
            ModalConfirmFormBtnOk,
            ModalConfirmFormBtnCancel,
            ModalConfirmFormValue,
            ModalFormTextArea,           
            ModalFormTextAreaRequie,
            loadingFullpage,
            leaveTypeCategory,
            statusForm,
            modalGuideLineTax,
            manualLeave,
            remarkText,
            leaveDayAllData,
            historyYear,
            showStatus
        } = this.state

		return (
            <Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การลา / ดูเอกสารการลา </span>
                    {/* </Breadcrumb.Item> */}
                </div>
                <Modal
                    visible={showModalNote}
                    title={titleModal}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <p>{noteModal}</p>
                </Modal>
               
                  <ModalConfirmForm 
                     title={ModalConfirmFormTitle} 
                     subtitle={ModalConfirmFormSubTitle}
                     showModal={ModalConfirmFormShowModal} 
                     btnOk={ModalConfirmFormBtnOk} 
                     btnCancel={ModalConfirmFormBtnCancel}  
                     submitToSend={ this.sendToCreateLeave }
                     hideModal={ this.hideModalConfirm }
                     valueConfirm = { ModalConfirmFormValue }
                     ModalFormTextArea = {ModalFormTextArea}
                     ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
                  />

                {
                    detailProfile && detailForm ?
                        <Spin spinning={loadingFullpage} delay={500}>
                           <div className="card-container h-100" id="page-profile">
                              <Form ref={this.formRef} onSubmit={this.handleSubmit}>
                                 <div className="px-5 pt-5 pb-5 card-bg-green">
                                       <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                          <Col xs={24} md={24} className="pt-2">
                                             <strong className="color-red">
                                                   ข้อมูลบุคลากร
                                             </strong>
                                          </Col>

                                          <Col xs={24} md={8} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={detailProfile.empName} required={false} name={"name"} label="ชื่อบุคลากร" mode={"text"} />
                                          </Col>

                                          <Col xs={24} md={8} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={detailProfile.division ? detailProfile.division : '-'} required={false} name={"diviName"} label="ฝ่าย" mode={"text"} />
                                          </Col>

                                          <Col xs={24} md={8} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={detailProfile.department ? detailProfile.department : '-'} required={false} name={"deptName"} label="หน่วยงาน" mode={"text"} />
                                          </Col>

                                          
                                       </Row>
                                 {/* </div> */}

                                 {/* <div className="px-5 pb-5 card-bg-green"> */}
                                       <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                          <Col xs={24} md={12} className="pt-2">
                                             <strong className="color-red">
                                                ข้อมูลการลา
                                             </strong>
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 text-right">
                                          {
                                             manualLeave.length > 0 ?
                                                <>
                                                   <div align="right" className="div-guild-line">
                                                         <p  style={{width:"auto", cursor:"pointer", textDecoration:"underline", color:"blue"}} onClick={ async () => this.setState({modalGuideLineTax:true}) }>
                                                            คู่มือการใช้งาน 
                                                         </p>
                                                      </div>

                                                      <Modal
                                                         destroyOnClose={true}
                                                         visible={modalGuideLineTax}
                                                         maskClosable={false}
                                                         title={"คู่มือการใช้งาน"}
                                                         onCancel={ async () => await this.setState({modalGuideLineTax:false})}
                                                         width={600}
                                                         okText={ "" }
                                                         cancelText={ "ปิด" }
                                                         footer={null}
                                                      >
                                                         <Row gutter={16} type="flex" justify="left" align="top" >
                                                            <Col xs={24} md={24} >
                                                               <ol className="pl-3">
                                                               {
                                                                   manualLeave.map((values, keys)=>{
                                                                     if(values.typeValue == 'file'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ checkLinkURL()+values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }else if(values.typeValue == 'link'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }
                                                                  })
                                                               }
                                                               </ol>
                                                            </Col>

                                                            <Col xs={24} md={24} align="right">
                                                               <Button 
                                                                  type="primary " 
                                                                  className="mt-1 color-white"
                                                                  htmlType="submit"
                                                                  onClick={ async () => await this.setState({modalGuideLineTax:false}) }
                                                               >
                                                                  ปิด
                                                               </Button>
                                                            </Col>
                                                         </Row>
                                                        
                                                      </Modal>
                                                </>
                                             :
                                             ''
                                          }
                                          </Col>
                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={ detailForm.docNo ? detailForm.docNo : '-' } required={false} name={"docId"} label="เลขที่เอกสาร" mode={"text"} />
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={ showStatus ? approveStatusNew(showStatus) : '-' } required={false} name={"status"} label="สถานะเอกสาร" mode={"text"} />
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <Form.Item label={'วันที่ยื่นเรื่อง'} className="mb-0">
                                                   { getFieldDecorator('documentDate', {
                                                      initialValue: moment(detailForm.documentDate),
                                                      rules:  [{ 
                                                         required:true, 
                                                         message: 'กรุณากรอกหรือเลือก วันที่ยื่นเรื่อง',
                                                      }],
                                                   })(
                                                      <DatePicker 
                                                         format={this.dateFormatNumber("documentDate")} 
                                                         placeholder="" 
                                                         style={{ width:"100%" }} disabled={true}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <FromInput disabled={true} value={detailForm.leaveTypeName} required={false} name={"leaveTypeName"} label="ประเภทการลา" mode={"text"} />
                                             {/* <Form.Item label={"ประเภทการลา"}>
                                                   { this.props.form.getFieldDecorator("leaveTypeId", {
                                                      initialValue: detailForm.leaveTypeId,
                                                      rules:  [{ 
                                                         required: true, 
                                                         message: 'กรุณากรอกเลือกประเภทการลา',
                                                      }],
                                                   })(
                                                      <Select 
                                                         style={{ width: "100%" }}
                                                         showSearch
                                                         placeholder="กรุณาเลือก"
                                                         optionFilterProp="children"
                                                         disabled={true}
                                                         onChange={ (e) => this.onChangeTypeLeave(e) }
                                                      >
                                                         {
                                                               dropdownLeaveType.length !== 0 ? 
                                                                  dropdownLeaveType.map((valuseLabel, keysLabel) =>{
                                                                     return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
                                                                  })
                                                               : ''
                                                         }
                                                      </Select>
                                                   )}
                                             </Form.Item> */}
                                          </Col>

                                          <Col xs={ 24 } md={12}>
                                             <Form.Item label="วันที่เริ่มลา" className="mb-0">
                                                   { getFieldDecorator('leaveStartDate', {
                                                      initialValue: moment(detailForm.leaveStartDate),
                                                      rules:  [{ 
                                                         required: true, 
                                                         message: 'กรุณากรอกหรือเลือก วันที่เริ่มลา',
                                                      }],
                                                   })(
                                                      <DatePicker 
                                                         format={this.dateFormatNumber("leaveStartDate")} 
                                                         className="w-100"  
                                                         placeholder="เลือกวันที่"
                                                         disabled={true} 
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>
                                          
                                          <Col xs={ 24 } md={12}>
                                             <Form.Item label="วันที่สิ้นสุดการลา" className="mb-0">
                                                   { getFieldDecorator('leaveEndDate', {
                                                      initialValue: moment(detailForm.leaveEndDate),
                                                      rules:  [{ 
                                                         required:true,
                                                         message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดการลา',
                                                      }],
                                                   })(
                                                      <DatePicker 
                                                         format={this.dateFormatNumber("leaveEndDate")} 
                                                         disabled={ true }
                                                         className="w-100" 
                                                         // defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                                                         placeholder="เลือกวันที่"
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <FromInput
                                                   disabled={true} 
                                                   value={ reDurationType(detailForm.durationType) } 
                                                   required={false} 
                                                   name={"name"} 
                                                   label="ช่วงเวลาการลา" 
                                                   mode={"text"} 
                                             />
                                          </Col>

                                          <Col xs={24} md={12} className="pt-2 mb-1">
                                             <Form.Item label={"จำนวนวันลา"} className="mb-0">
                                                   { this.props.form.getFieldDecorator("leaveDay", {
                                                      initialValue: detailForm.leaveDay,
                                                      rules:  [{ 
                                                         required: true, 
                                                         message: 'กรุณากรอกเลือกจำนวนวันลา',
                                                      }],
                                                   })(
                                                      <Input 
                                                         className='block-news' 
                                                         disabled={true}
                                                         hidden={leaveTypeCategory == 'Custom' ? true : false}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          {
                                                leaveTypeCategory == 'Custom' &&
                                                <>
                                                   <Col xs={24} md={12}>
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="shiftCode" values={detailForm.shiftCode} label="รหัสกะงาน" /> */}
                                                      <FromInput disabled={true} value={ detailForm.shiftCode } required={false} name={"leaveTypeName"} label="รหัสกะงาน" mode={"text"} />
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="shiftTime" values={detailForm.shiftTime} label="เวลาทำงานของกะงาน" /> */}
                                                      <FromInput disabled={true} value={ detailForm.shiftTime } required={false} name={"shiftTime"} label="เวลาทำงานของกะงาน" mode={"text"} />
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveStartTime } required={false} name={"leaveStartTime"} label="เวลาเริ่มต้น" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveStartTime" values={detailForm.leaveStartTime} label="เวลาเริ่มต้น" /> */}
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveEndTime } required={false} name={"leaveEndTime"} label="เวลาสิ้นสุด" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveEndTime" values={detailForm.leaveEndTime} label="เวลาสิ้นสุด" /> */}
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveHour ? detailForm.leaveHour.label : '' } required={false} name={"leaveHour"} label="จำนวนชั่วโมงการลา" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveHour" values={detailForm.leaveHour ? detailForm.leaveHour.value : ''} label="จำนวนชั่วโมงการลา" /> */}
                                                   </Col>
                                                </>
                                          }

                                          {/* <Col xs={24} md={12}>
                                             <Form.Item label={"รหัสกะงาน"} className="mb-0">
                                                   { this.props.form.getFieldDecorator("leaveDay", {
                                                      rules:  [{ 
                                                         // required: true, 
                                                         message: 'กรุณากรอกระบุ รหัสกะงาน',
                                                      }],
                                                   })(
                                                      <Input 
                                                         className='block-news' 
                                                         disabled={true}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          <Col xs={24} md={12}>
                                             <Form.Item label={"เวลาทำงานของกะงาน"}  className="mb-0">
                                                   { this.props.form.getFieldDecorator("leaveDay", {
                                                      rules:  [{ 
                                                         // required: true, 
                                                         message: 'กรุณากรอกระบุ เวลาทำงานของกะงาน',
                                                      }],
                                                   })(
                                                      <Input 
                                                         className='block-news' 
                                                         disabled={true}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          <Col xs={24} md={12}>
                                             <Form.Item label={"เวลาเริ่มต้น"}  className="mb-0">
                                                   { this.props.form.getFieldDecorator("time1", {
                                                      // initialValue: item,
                                                      rules:  [{ 
                                                         message: 'กรุณาระบุ เวลาเริ่มต้น',
                                                      }],
                                                   })(
                                                      <TimePicker 
                                                         format={format} 
                                                         className="w-100"
                                                         placeholder="" 
                                                         // disabledHours={() => this.getDisabledHours(record)}
                                                         // disabledMinutes={(e) => this.getDisabledMinutes(e, record)}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col>

                                          <Col xs={24} md={12}>
                                             <Form.Item label={"เวลาสิ้นสุด"}  className="mb-0">
                                                   { this.props.form.getFieldDecorator("time2", {
                                                      // initialValue: item,
                                                      rules:  [{ 
                                                         message: 'กรุณาระบุ เวลาสิ้นสุด',
                                                      }],
                                                   })(
                                                      <TimePicker 
                                                         format={format} 
                                                         className="w-100"
                                                         placeholder="" 
                                                         // disabledHours={() => this.getDisabledHours(record)}
                                                         // disabledMinutes={(e) => this.getDisabledMinutes(e, record)}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </Col> */}

                                          
                                          <Col xs={24} md={24}  className="pt-2">
                                             <Form.Item label={"หมายเหตุ"}>
                                                   { getFieldDecorator("description", {
                                                      initialValue: detailForm.description,
                                                      rules:  [{ 
                                                         // required: true, 
                                                         message: 'กรุณากรอกหรือเลือก ประเภทสถานพยาบาล',
                                                      }],
                                                   })(
                                                      <TextArea rows={3} className='block-news' disabled={ true } />
                                                   )}
                                             </Form.Item>
                                          </Col>
                                          
                                          <Col xs={24} md={24}  className="" >
                                             <ComponetsRemarkText remarkText={remarkText}/>
                                          </Col>
                                       </Row>
                                 {/* </div> */}

                                 {  
                                    (statusForm == 'W' && leaveDayAllData.length !== 0) &&
                                       <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                          <Col xs={24} md={24} className="mb-5">
                                             <strong className="color-red">
                                                ประวัติการลาประจำปี {historyYear}
                                             </strong>
                                          </Col>
                                          <Col xs={24} md={24}>
                                             <Row gutter={16} type="flex"  align="top" className="box-show-number px-4 mb-4">
                                                   {/* <Col xs={24} md={6} className="" align={"center"} style={{ borderRight:"1px solid #c5c4c4" }}> */}
                                                   <Col xs={24} md={9} className="" align={"center"}>
                                                      <strong className="">
                                                         ประเภทการลา
                                                      </strong>
                                                   </Col>
                                                   <Col xs={24} md={5} className="" align={"right"}>
                                                      <strong className="">
                                                         สิทธิการลา
                                                      </strong>
                                                   </Col>
                                                      <Col xs={24} md={5} className="" align={"right"}>
                                                      <strong className="color-orange">
                                                         วันลาคงเหลือ
                                                      </strong>
                                                   </Col>
                                                   <Col xs={24} md={5} className="" align={"right"}>
                                                      <strong className="color-green">
                                                         วันลาที่ใช้ไปแล้ว
                                                      </strong>
                                                   </Col>
                                             </Row>
                                             {
                                                leaveDayAllData.map((values, keys)=>{
                                                   return   <Row type="flex" gutter={16}  align="top" className="box-show-number  px-4 ">
                                                                     <Col xs={24} md={8} className="" align={"left"}>
                                                                           <p className="mb-1">
                                                                              {values.leaveTypeName}<br></br>
                                                                           </p>
                                                                     </Col>
                                                                     
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={ values.leaveDay || values.leaveDay == 0 ? 'numberLeav' : '' }>
                                                                              { values.leaveDay || values.leaveDay == 0 ? values.leaveDay : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.remainLeaveDay || values.remainLeaveDay == 0 ? 'numberLeav color-orange' : 'color-orange'}>
                                                                              { values.remainLeaveDay || values.remainLeaveDay == 0 ? this.checkLeaveDayAllValue(values.remainLeaveDay.toString()) : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.currentLeaveDay || values.currentLeaveDay == 0 ? 'numberLeav color-green' : 'color-green'}>
                                                                              { values.currentLeaveDay || values.currentLeaveDay == 0 ? this.checkLeaveDayAllValue(values.currentLeaveDay.toString()) : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     
                                                                     <Col md={24}>
                                                                        <hr></hr>
                                                                     </Col>
                                                                  </Row>
                                                })
                                             }
                                          </Col>
                                       </Row>
                                 }
                                 
                                 {/* <div className="px-5 pb-5 card-bg-green"> */}
                                       <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                          <Col xs={24} md={24} className="pt-2 mb-3">
                                             <strong className="color-red">
                                                   เอกสารแนบ
                                             </strong>
                                          </Col>
                                          
                                          <Col xs={24} md={24} align={"right"}>
                                             <Table
                                                   columns={columns}
                                                   dataSource={dataTalbeUploads}
                                                   pagination={false}
                                                   className="mb-3"
                                                   bordered
                                                   // rowCount={dataTalbeUploads.length}
                                                   // pagination={{ pageSize: dataTalbeUploads.length }}
                                                   pagination={false}
                                                   locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                             />
                                             {/* <Button 
                                                   style={{ display:"inline-block" }}
                                                   type="primary btn-color-default btn-custom btn-clear color-white" 
                                                   className="mt-1 mr-2"
                                                   onClick={ () => this.showDataInputUploads() }
                                             >
                                                   เพิ่ม +
                                             </Button> */}
                                          </Col>
                                       </Row>
                                 {/* </div> */}

                                 {/* <div className="px-5 py-1 card-bg-green"> */}
                                       <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mt-4" >
                                          <Col xs={24} md={24} className="pt-2 mb-4">
                                             <strong className="color-red">
                                                   ประวัติการลาที่อนุมัติ
                                             </strong>
                                             <Table
                                                   locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                   columns={columnsPeople}
                                                   dataSource={dataTalbePeople}
                                                   pagination={false}
                                                   className="mt-4"
                                                   loading={loadingColumnsPeople}
                                                   bordered
                                                   rowCount={dataTalbePeople.length}
                                             />
                                          </Col>
                                       </Row>
                                 {/* </div> */}
                                 {
                                       statusForm == 'W' &&
                                       <Row gutter={16} type="flex" justify="left" align="top" >
                                             <Col xs={24} md={24} align={"center"}>
                                                <Button type="primary" className="ml-2 btn-white-red" htmlType="submit" onClick={this.handleSubmitCancel} disabled={ preLoadOnsubmit }>
                                                      ไม่อนุมัติ
                                                </Button>
                                                <Button type="primary" className="ml-2 color-white" htmlType="submit" disabled={ preLoadOnsubmit }>
                                                      อนุมัติ
                                                </Button>
                                             </Col>                                       
                                       </Row>
                                    }
                                 </div>
                              </Form>
                           </div>
                        </Spin>
                    :
                    showNullForm &&
                        <Row>
                            <Col align="center" className="mt-5">
                                {/* <Spin size="large" /> */}
                                <Title level={4} className="mb-0" align="center">
                                    -- ไม่พบข้อมูลการลา --
                                </Title>
                            </Col>
                        </Row>
                    ||
                        <Row>
                            <Col align="center" className="mt-5">
                                <Spin size="large" />
                            </Col>
                        </Row>
                }
                
            </Container>
		)
	}
}

Withdraw.defaultProps = {
	autoFocus: false
}

Withdraw.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedWithdraw = Form.create()(Withdraw)

export default withApollo(WrappedWithdraw)